const compareHousePopup = document.querySelector('.compare-house-popup');

const getCompareCookie = () => {
  const cookieValue = Cookies.get('house_compare');
  if (cookieValue) {
    return JSON.parse(cookieValue);
  }
  return false;
};

const setCompareCookie = (array) => {
  Cookies.set('house_compare', JSON.stringify(array), { expires: 365 });
};

const addToCompareCookie = (productId) => {
  const cookieArray = getCompareCookie();
  if (!cookieArray) {
    setCompareCookie([productId]);
  }

  if (!cookieArray.includes(productId)) {
    cookieArray.push(productId);
    setCompareCookie(cookieArray);
  }
};

const removeFromCompareCookie = (productId) => {
  const cookieArray = getCompareCookie();
  if (cookieArray) {
    const index = cookieArray.indexOf(productId);
    if (index > -1) {
      cookieArray.splice(index, 1);

      if (cookieArray.length === 0) {
        Cookies.remove('house_compare');
        return;
      }

      setCompareCookie(cookieArray);
    }
  }
};

if (compareHousePopup) {
  const cloneEmptyItem = compareHousePopup.querySelector('.compare-house-popup__house');
  const compareAlertModal = document.querySelector('.modal--compare-alert');

  attachEvent('.compare-house-popup__house-remove', 'click', (ev) => {
    const productId = ev.target.closest('.compare-house-popup__house-inner').getAttribute('data-product-id');
    const parentListEle = ev.target.closest('.compare-house-popup__list');
    ev.target.closest('.compare-house-popup__house')?.remove();
    removeFromCompareCookie(productId);

    const clonedItem = cloneEmptyItem.cloneNode(true);
    clonedItem.classList.remove('is-active');
    clonedItem.querySelector('.compare-house-popup__house-inner')?.remove();
    parentListEle.append(clonedItem);

    if (!parentListEle.querySelector('.compare-house-popup__house.is-active')) {
      setTimeout(() => compareHousePopup.classList.add('is-empty'), 300);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const compareItems = document.querySelectorAll('.compare-house-popup__house-inner');
    if (compareItems.length === 0) {
      compareHousePopup.classList.add('is-empty');
    }
  });

  attachEvent('.btn--compare', 'click', (ev) => {
    const btn = ev.target.closest('.btn--compare');
    const productImage = btn.getAttribute('data-image');
    const productTitle = btn.getAttribute('data-title');
    const productLink = btn.getAttribute('data-link');
    const productId = btn.getAttribute('data-product-id');

    const compareList = compareHousePopup.querySelector('.compare-house-popup__list');

    const isAlreadyAdded = Array.from(compareList.querySelectorAll('.compare-house-popup__house-inner')).some(
      (item) => item.getAttribute('data-product-id') === productId,
    );

    compareHousePopup.classList.add('is-open');

    setTimeout(() => {
      compareHousePopup.classList.remove('is-open');
    }, 3000);

    if (isAlreadyAdded) return;

    const emptySlot = compareList.querySelector('.compare-house-popup__house:not(.is-active)');

    if (!emptySlot) {
      compareAlertModal?.classList.add('is-open-modal');
      return;
    }

    if (emptySlot) {
      emptySlot.classList.add('is-active');
      emptySlot.innerHTML = `
        <div class="compare-house-popup__house-inner" data-product-id="${productId}">
          <button type="button" class="compare-house-popup__house-remove : d-flex-cc" aria-label="Remove Product">
            <i data-component="at-icon" class="icon : icon-close"></i>
          </button>
          <div class="compare-house-popup__house-image : d-flex-cc">
            <img src="${productImage}" alt="${productTitle}" width="72" height="58">
          </div>
          <div class="compare-house-popup__house-title : text--uppercase : text--sb">${productTitle}</div>
          <a href="${productLink}" aria-label="View details of ${productTitle}" class="compare-house-popup__house-link : stretched-link"></a>
        </div>
      `;

      compareHousePopup.classList.remove('is-empty');
      addToCompareCookie(productId);
    }
  });

  attachEvent('.compare-house-popup__trigger', 'click', () => {
    compareHousePopup.classList.toggle('is-open');
  });
}
